import React, { useEffect, useRef } from 'react';
import { BrowserRouter, createBrowserRouter, RouterProvider } from "react-router-dom";
import PageMain from "./page/page.main";
import { Theme, presetGpnDefault } from '@consta/uikit/Theme';
import { PageLogin } from "./page/login/page.login";
import WrapperAuthCmp from "./component/wrapper.auth.cmp";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()

type VersionPayload = { version?: string };

const VERSION_URL = "/version.json";
const CHECK_INTERVAL_MS = 30_000;

const App = () => {
  const currentVersionRef = useRef<string | null>(null);
  const intervalIdRef = useRef<number | null>(null);
  const startedRef = useRef(false); // защита от двойного запуска в React.StrictMode (dev)

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const checkVersion = async () => {
      try {
        const res = await fetch(VERSION_URL, {
          cache: "no-store",
          headers: { "Cache-Control": "no-cache" },
        });

        if (!res.ok) return;

        const data = (await res.json()) as VersionPayload;
        const nextVersion = typeof data.version === "string" ? data.version : null;
        if (!nextVersion) return;

        // первый успешный ответ — просто запоминаем
        if (currentVersionRef.current === null) {
          currentVersionRef.current = nextVersion;
          return;
        }

        // версия изменилась — перезагружаем вкладку
        if (currentVersionRef.current !== nextVersion) {
          window.location.reload();
        }
      } catch {
        // сетевые ошибки игнорируем (не мешаем пользователю работать)
      }
    };

    void checkVersion();
    intervalIdRef.current = window.setInterval(() => void checkVersion(), CHECK_INTERVAL_MS);

    return () => {
      if (intervalIdRef.current !== null) {
        window.clearInterval(intervalIdRef.current);
      }
    };
  }, []);

  const router = createBrowserRouter([
    {
      path: "/main",
      element: <PageMain loading={false} />
    },
    {
      path: "/login",
      element: <PageLogin />
    },
  ]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Theme preset={presetGpnDefault}>
          <WrapperAuthCmp>
            <RouterProvider router={router} />
          </WrapperAuthCmp>
        </Theme>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
